<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    const name = 'factoring/success'
    if (
      [name, 'signup/woori-crowd/application'].includes(this.$route.name) === false &&
      this.routerStatusRedirect
    ) {
      return await this.$router.replace({ name })
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
